export default __webpack_public_path__ + "static/tiktok-ac12e329a38b4d59dc7b0804de404df1.svg";